import * as _ from "lodash";

import { ExtensionBase } from "../extensionBase";
import { UiUtils } from "../../common/uiUtils";
import { viewerOptions } from "../../viewer";
import { ViewerUtils } from "../../common/viewerUtils";
import * as SmartDrawings from "../../smartDrawings";
import ExternalData = SmartDrawings.ExternalData;
import { ModelApi } from "../../api/modelApi";

export class LegendPropertyExtension extends ExtensionBase {
    static extensionName = "LegendPropertyExtension";

    private subToolbar: Autodesk.Viewing.UI.ControlGroup;
    private legendPropertyButton: any; //Autodesk.Viewing.UI.ComboButton;

    private legendProperty: string;
    private colorScheme: SmartDrawings.ColorScheme;

    constructor(viewer: Autodesk.Viewing.GuiViewer3D, options: any) {
        super(viewer, options);
    }

    static registerExtension() {
        super.registerExtension(LegendPropertyExtension.extensionName, LegendPropertyExtension);
    }

    load(): boolean {
        console.log(`${LegendPropertyExtension.extensionName} is loaded!`);
        return super.load();
    }

    unload(): boolean {
        return super.unload();
    }

    async onToolbarCreated() {
        if (this.checkUda()) {
            this.legendPropertyButton = UiUtils.createComboButton({
                id: "SmartDrawings.LegendPropertyButton",
                //tooltip: "Update legend property",
                iconClass: "ion-md-done-all"
            });

            this.legendPropertyButton.setState(Autodesk.Viewing.UI.Button.State.DISABLED);

            this.subToolbar = this.getControlGroup("SmartDrawings.ExtDataExtensions");
            this.subToolbar.addControl(this.legendPropertyButton);

            this.viewer.addEventListener(SmartDrawings.SdEvents.PARAMS_TO_DBIDS_MAPPED,
                this.onExternalDataLoaded.bind(this));
        }
    }

    async onExternalDataLoaded() {
        await this.initPropertyValues();
        this.legendPropertyButton.setState(Autodesk.Viewing.UI.Button.State.INACTIVE);
        this.viewer.removeEventListener(SmartDrawings.SdEvents.PARAMS_TO_DBIDS_MAPPED,
            this.onExternalDataLoaded.bind(this));
    }

    private checkUda(): boolean {
        const { userDefinedAttributes } = viewerOptions;
        if (userDefinedAttributes == null)
            return false;

        if (userDefinedAttributes["legendProperty"]) {
            this.legendProperty = userDefinedAttributes["legendProperty"];

            return true;
        }

        return false;
    }

    private async initPropertyValues() {
        let schemes: SmartDrawings.ColorScheme[] = viewerOptions.externalData.idSchemes.customColorSchemes;
        let defs: SmartDrawings.PropertyDefinition[] = viewerOptions.externalData.propertyDefinitions;
        this.colorScheme = _.find(schemes, s => s.id === defs[this.legendProperty].legendId);

        for (let color in this.colorScheme.colors) {
            const c = this.colorScheme.colors[color];
            const valueButton: any = UiUtils.createButton({
                id: `legendButton_${c.description}`,
                onClick: async () => { await this.updateProperty(c); }
            });
            valueButton.container.innerHTML = `<div class="color-box" style="background-color: rgba(${c.color.r},${c.color.g},${c.color.b},${c.color.a})" /></div>
                <div style="width: max-content">${_.escape(c.description)}</div>`;
            valueButton.addClass("toolbar-text-button");
            this.legendPropertyButton.addControl(valueButton);
        }
    }

    private async updateProperty(cData: SmartDrawings.ColorData) {
        const elements = this.viewer.getSelection();
        if (elements.length > 0) {
            const props = viewerOptions.externalData.propertyValues;
            const updateData = {};
            for (let element of elements) {
                const mappedId = await this.findMappedId(element);
                if (mappedId) {
                    if (mappedId in props) {
                        let updated = props[mappedId];
                        updated[this.legendProperty] = cData.id;
                        updateData[mappedId] = updated;
                    }
                }
            }

            if (Object.keys(updateData).length > 0) {
                const result = await ModelApi.updateExternalData(viewerOptions.guid, updateData).catch(err => console.log(err.response));

                if (result) {
                    const data = result.data;
                    const extIdMapping = viewerOptions.externalData.paramsToDbIds;
                    viewerOptions.externalData = data;
                    viewerOptions.externalData.paramsToDbIds = extIdMapping;
                    UiUtils.notifySuccess(`Selected parts updated to: ${cData.description}`);
                    this.viewer.dispatchEvent({ type: SmartDrawings.SdEvents.EXTERNAL_DATA_CHANGED });
                }
            }
        }
        this.viewer.clearSelection();
    }

    private async findMappedId(nodeId: number) {
        var extData: ExternalData = viewerOptions.externalData;
        const mappedId = _.keys(extData.paramsToDbIds).filter(id => extData.paramsToDbIds[id] === nodeId);
        if (mappedId.length > 0) {
            return mappedId[0];
        }

        // Or try to find data in the parent.
        const parentId = await ViewerUtils.getNodeParent(nodeId, this.viewer);
        if (parentId != null) {
            return await this.findMappedId(parentId);
        }

        return null;
    }
}